// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"367":"4b43c9c9","394":"b982536e","501":"c53a9eb6","642":"959dcb01","656":"c9e1e761","880":"0ec2dbd6","900":"2eff6adb","922":"1fc28c81"}[chunkId] + ".js";
};